module.exports = __webpack_public_path__ + "static/media/hosp1.634807ed.jpeg";